import { ChangeDetectionStrategy, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { WrapPanelItemDirective } from '../../directives/wrap-panel-item.directive';

@Component({
  selector: 'fb-wrap-panel',
  templateUrl: './wrap-panel.component.html',
  styleUrls: ['./wrap-panel.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WrapPanelComponent {
  @Input() xOffset: number = 16;
  @Input() yOffset: number = 8;

  @ContentChildren(WrapPanelItemDirective) items: QueryList<WrapPanelItemDirective<object>>;
}
